import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const EnergiesRenouvelables = () => {
  const sectorData = {
    title: "Énergies Renouvelables",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Photovoltaïque, biomasse, hydraulique, les solutions d'énergies vertes doivent sensibiliser des cibles publiques ou privées. Positionner des simulateurs de gains CO2, des références territoriales et des outils de pré-diagnostic est stratégique pour accélérer la prise de contact.",
    name: "Énergies Renouvelables",
    titleContext: "du secteur des énergies renouvelables",
    responseContext: "du secteur des énergies renouvelables",
    expertContext: "du secteur des énergies renouvelables"
  };

  return <SectorPage sector={sectorData} />;
};

export default EnergiesRenouvelables; 